import { useState } from "react";
import { useNavigate } from "react-router-dom";

const JoinGame = () => {
  const navigate = useNavigate();

  const [gameId, setGameId] = useState("");

  const handleInputChange = (event) => {
    setGameId(event.target.value.toUpperCase());
  };

  const handleKeyUp = (event) => {
    if (event.key === "Enter") {
      joinGame();
    }
  };

  const joinGame = async () => {
    if (!gameId) return;

    try {
      const response = await fetch("/api/joinGame", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ gameId }),
      });

      const data = await response.json();
      console.log("Server response:", data);
      navigate("/play");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <div className="card">
      <h3 className="subtitle">Join Game</h3>

      <div className="form-group">
        <label htmlFor="gameCode">Enter game code:</label>
        <input
          type="text"
          id="gameCode"
          value={gameId}
          onChange={handleInputChange}
          onKeyUp={handleKeyUp}
          placeholder="Type something..."
          className="textbox"
        />
        <button onClick={joinGame} className="button">Join</button>
      </div>
    </div>
  );
};

export default JoinGame;
